var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("도서 & 상품검색 결과")])]), _c('product-list', {
    attrs: {
      "searchKey": "name",
      "searchValue": _vm.$route.query.searchValue,
      "routable": false
    }
  })], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }